interface BuildMetadata {
    buildID?: string;
    version?: string;
    gitHead?: { commitHash?: string; committerDate?: string };
    builtTime?: string;
}

/**
 * Prefer per-build identity while accepting metadata emitted by older deployments.
 * A missing signature is not evidence of an update and must not trigger a prompt.
 */
export function getBuildSignature(metadata: BuildMetadata): string | null {
    return metadata?.buildID || metadata?.version || metadata?.gitHead?.commitHash
        || metadata?.gitHead?.committerDate || metadata?.builtTime || null;
}

/**
 * Compare deployed metadata with the bundle already loaded in this browser.
 * Embedded identity detects deployments that occurred before the first poll;
 * a fetched baseline is only a fallback when comparable identities are absent.
 */
export function isNewBuild(metadata: BuildMetadata, runningBuildID: string, runningVersion: string,
    initialSignature: string | null): boolean {
    if (runningBuildID && metadata?.buildID) {
        return metadata.buildID !== runningBuildID;
    }
    if (runningVersion && metadata?.version) {
        // Preserve full-version comparison for older bundles/metadata, including
        // distinct dev deployments that retain the same stable release version.
        return metadata.version !== runningVersion;
    }
    // Legacy metadata without a comparable embedded version needs one initial
    // observation before a later change can be recognized as an update.
    const signature = getBuildSignature(metadata);
    return !!signature && !!initialSignature && signature !== initialSignature;
}
